// extracted by mini-css-extract-plugin
export default {"gridForm":"OIDCSSOProviderForm_gridForm__Z2+uw","singleSignOnServiceUrl":"OIDCSSOProviderForm_singleSignOnServiceUrl__8Rkfd","tokenUrl":"OIDCSSOProviderForm_tokenUrl__pOP5p"};